import Icon from '@material-ui/icons/CloudUpload';
import cdcsList from './CdcsDonationsList'

export default {
    list: cdcsList,
    //edit: ShipmentEdit,
    //create: DonorCreate,
    icon: Icon,
};
